import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "@/utils/global-views"
import { identityApi } from "@ba/visary-account-common-vue"

Vue.config.productionTip = false

identityApi.configure(process.env.VUE_APP_IDENTITY_API_BASE_URL)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
